module.exports = __webpack_public_path__ + "img/avatar4.8b8d082.svg";